import { Component, input } from '@angular/core';
import { THREAD_AGENT_SERVICE } from 'src/app/features/general-agent/tokens/thread-agent.token';
import { THREAD_AGENT_CONFIG, DOCUMENT_CHAT_THREAD_CONFIG } from 'src/app/features/general-agent/tokens/thread-agent-config.token';
import { ChatTabShellComponent } from 'src/app/features/general-agent/components/chat-tab-shell/chat-tab-shell.component';
import { ChatService } from '../../services/chat.service';
import { CHAT_TYPE, THREAD_TYPE } from '../../models/chat.model';

@Component({
    selector: 'app-document-chat-tab',
    standalone: true,
    imports: [ChatTabShellComponent],
    providers: [
        { provide: CHAT_TYPE, useValue: THREAD_TYPE.DOCUMENT_CHAT },
        ChatService,
        { provide: THREAD_AGENT_SERVICE, useExisting: ChatService },
        { provide: THREAD_AGENT_CONFIG, useValue: DOCUMENT_CHAT_THREAD_CONFIG },
    ],
    templateUrl: './document-chat-tab.component.html',
})
export class DocumentChatTabComponent {
    contractId = input.required<string>();
    documentTypeId = input<string>('');
    projectId = input<string>('');
    formQuestions = input<{ _id: string; name: string; sectionTitle?: string }[]>([]);
    selectedFormQuestionId = input<string | null>(null);
    embeddingsStatus = input<boolean>(true);
}
